





















































































































import {Component, Watch, Mixins} from 'vue-property-decorator';
import EditDialogMixin from '@/mixins/dialog/EditDialogMixin';
import axios from 'axios';
import FlexGridImportSettingstEditDialog from '@/components/base/flex-grid/header/FlexGridImportSettingsEditDialog.vue';
import CEditDialog from '@/components/base/dialog/CEditDialog.vue';
import CSimpleTable from '@/components/base/table/CSimpleTable.vue';

/**
 * @requires ./FlexGridImportSettingsEditDialog.vue
 */
@Component({
    components: {CSimpleTable, CEditDialog, FlexGridImportSettingstEditDialog},
})
export default class FlexGridHeaderImportDialog extends Mixins(EditDialogMixin) {
    private selectValue: number | null = null;
    private importOnlyNotAnyErrors: boolean = false;
    private importOnlyNotCriticalErrors: boolean = false;
    private deleteExistedData: boolean = false;
    private file: any = null;
    private response: any = null;

    get fileInputRules() {
        return [
            (v: any) => {
                if (Array.isArray(v) && v.length === 0) return true;
                else if (v === null) return this.$t('Common.FlexGrid.ImportPickFileMsg');
                else {
                    return /(.xls$|.xlsx)$/.test(v.name) || this.$t('Common.FlexGrid.ImportInvalidFormatMsg');
                }
            },
        ];
    }

    @Watch('importOnlyNotAnyErrors')
    onImportOnlyNotAnyErrors(value: boolean) {
        if (value) this.importOnlyNotCriticalErrors = true;
    }

    init(data: any) {
        this.data = data;
        this.selectValue = data.IdCurrentConfigImportItem;
    }

    clear() {
        this.data = null;
        this.importOnlyNotAnyErrors = false;
        this.importOnlyNotCriticalErrors = false;
        this.deleteExistedData = false;
        this.file = null;
        this.response = null;
    }

    async save() {
        const form = this.$refs.form as any;
        if (!form) {
            console.warn('form ref not found at validation state');
        }
        this.valid = form.validate();
        if (this.valid) {
            try {
                await this.import();
                this.$emit('reload');
            } catch (e) {
                console.error(e);
            }
        }
    }

    async import() {
        const timerId = setTimeout(() => (this.loading = true), 100);
        const postData = new FormData();
        postData.append('file', this.file);
        try {
            const {data} = await this.$http.post(`${this.options.url}/Import`, postData, {
                params: {
                    ...this.options.query,
                    idGridConfigImportItem: this.selectValue,
                    importOnlyNotAnyErrors: this.importOnlyNotAnyErrors,
                    importOnlyNotCriticalErrors: this.importOnlyNotCriticalErrors,
                    deleteExistedData: this.deleteExistedData,
                },
            });
            this.response = data;
            if (data.CountItemsDelete > 0 || data.CountItemsAdded > 0) this.$emit('refresh');
        } finally {
            clearTimeout(timerId);
            if (this.loading) this.loading = false;
        }
    }

    onImportEdit() {
        const options = {
            type: 'edit',
            title: this.$t('Common.Edit'),
            saveCallback: (data: any) => {
                this.onImportSave(data);
            },
        };
        const CancelToken = axios.CancelToken,
            source = CancelToken.source();
        const request = this.$http.get(`${this.options.url}/GetConfigImportEdit`, {
            params: {
                ...this.options.query,
                idGridConfigImportItem: this.selectValue,
            },
            cancelToken: source.token,
        });
        (this.$refs.importEditDialog as any).openAsync(request, source, options);
    }
    async onImportSave(payload: any) {
        try {
            const {data: configs} = await this.$http.post(`${this.options.url}/SaveConfigImport`, payload, {
                params: {
                    ...this.options.query,
                },
            });
            this.data.ConfigImports = configs;
            this.$emit('update:import-configs', configs);
        } finally {
            (this.$refs.importEditDialog as any).close();
        }
    }
}
